import firebase from "firebase";


class ContactService {
  constructor(collectionName) {
    this.collectionName = collectionName;
  }
// getter for retriving document from firestore
  getDataById = async (id) => {
    
    try {
      const result = await firebase.firestore().collection(this.collectionName).doc(id).get();
      return result.data();    
    }
    catch(error) {
      window.alert('404 error');
    }
  }
}



export default ContactService;